import { useState, useEffect } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import GlobalStyles from "../../Resources/Styles";
import ExerciseRowView from "../Exercise/ExerciseRowView";
import { Feather } from "@expo/vector-icons";
import Colors from "../../Resources/Color";
import IconEmptyView from "../Components/IconEmptyView";

import { useTranslation } from "react-i18next";

import { observer, Observer } from "mobx-react";
import { useScreenDimensions, useDevice } from "../_layout";
import { shouldShowProtocolSlotUi } from "../platform/guards/coachBlockDashboardVisibility";

const WorkoutDescriptionView = observer(({ workout }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const showSetPriority =
    workout?.coach?.showSetPriority ??
    workout?.block?.coach?.showSetPriority ??
    workout?.block?.client?.coach?.showSetPriority ??
    true;

  const workoutCoach =
    workout?.coach ?? workout?.block?.coach ?? workout?.block?.client?.coach;
  const showProtocolSlotUi = shouldShowProtocolSlotUi(workoutCoach);

  const ToggleEditButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    const toggleEdit = () => {
      workout.setExercisesToAdd();
      //AQUI VA EL TOGGLE
      workout.setProperty("showingEditWorkout", true);
      if (workout.block && workout.block.client) {
        workout.block.client.setProperty("isHistoryShowing", false);
      }
    };
    return (
      <TouchableOpacity
        onPress={toggleEdit}
        style={{
          padding: 15,
          flexDirection: "row",
          alignItems: "baseline",
          opacity: isHovered ? 0.5 : 1,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Feather name="edit-3" size={13} color="black" />
        <Text style={{ marginLeft: 5 }}>{t("edit-string")}</Text>
      </TouchableOpacity>
    );
  };

  const FoldExercisesButton = observer(() => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => workout.showOrFoldAllExercises()}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ opacity: isHovered ? 0.5 : 1 }}
      >
        <Feather
          name={workout.exercisesShown ? "chevron-down" : "chevron-right"}
          size={20}
          color={Colors.bubbleColorConstant}
          style={{ padding: 10 }}
        />
      </TouchableOpacity>
    );
  });

  return (
    <View style={{ borderRadius: 14 }}>
      <View
        style={[
          GlobalStyles.HStack,
          {
            backgroundColor: Colors.lightGrayColor,
            borderTopRightRadius: 14,
            borderTopLeftRadius: 14,
            justifyContent:
              workout && workout.exercises && workout.exercises.length > 0
                ? "space-between"
                : "flex-end",
            height: 40,
            borderBottomWidth: 0.1,
            borderColor: Colors.borderColor,
          },
        ]}
      >
        {workout && workout.exercises && workout.exercises.length > 0 && (
          <FoldExercisesButton />
        )}

        <ToggleEditButton />
      </View>

      <View
        style={{
          backgroundColor: Colors.whiteColor,
          borderBottomRightRadius: 14,
          borderBottomLeftRadius: 14,
          gap: 12,
          // paddingRight: 12,
          paddingVertical: 10,
        }}
      >
        {workout && workout.exercises.length > 0 ? (
          workout.exercises
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((exercise) => (
              <ExerciseRowView
                key={exercise.id}
                exercise={exercise}
                showSetPriority={showSetPriority}
                showProtocolSlotUi={showProtocolSlotUi}
              />
            ))
        ) : (
          <IconEmptyView
            iconLibrary={"Ionicons"}
            mainText={"emptyExercisesTitle-string"}
            subText={"emptyExercisesText-string"}
            iconName={"barbell-outline"}
            marginTop={30}
            marginBottom={0}
            ctaText={"addExercises-string"}
            onCtaPress={() => {
              workout.setExercisesToAdd();
              workout.setProperty("showingEditWorkout", true);
              if (workout.block && workout.block.client) {
                workout.block.client.setProperty("isHistoryShowing", false);
              }
            }}
          />
        )}
      </View>
    </View>
  );
});

export default WorkoutDescriptionView;
